module.exports = __webpack_public_path__ + "img/helping-over-4500-mobile.f6ef82a6.svg";